import dayjs from 'dayjs';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatCurrency = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined) {
    return '-';
  }

  const numericValue = typeof value === 'string' ? Number(value) : value;
  if (Number.isNaN(numericValue)) {
    return '-';
  }

  return currencyFormatter.format(numericValue);
};

export const formatDate = (value?: string | null): string => {
  if (!value) {
    return '-';
  }

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('MMM DD, YYYY') : '-';
};
